import type {CourseApiModel} from '../../../api/course';
import type {Nullable} from '../../utility-types';

export const isCourseEditable = (course?: Nullable<CourseApiModel>) =>
  /**
   * TODO: should course be editable if it has "paused" status
   * many things such as event actions depend on this util
   */
  course?.status === 'ongoing';
